/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { FlexColumn, FlexRow, Typography } from 'design-system';
import { ExclamationCircleIcon } from 'design-system/components/Icons';

export function QuizPassMarkNote({ passMarkPercent }) {
  const intl = useIntl();

  return (
    <FlexRow
      align="center"
      fullWidth={false}
      gap="var(--ds-space-2)"
      className="ld-quiz__info"
    >
      <ExclamationCircleIcon
        size={13}
        className="ds-icon--color-muted"
        aria-hidden
      />
      <Typography component="p" variant="bodySmall" color="ui-subtle">
        {intl.formatMessage({ id: 'ld-pass-mark-note' }, { passMark: passMarkPercent })}
      </Typography>
    </FlexRow>
  );
}

QuizPassMarkNote.propTypes = {
  passMarkPercent: PropTypes.number.isRequired,
};

export default function QuizCardShell({
  questionLabel,
  footerStart,
  footerAction,
  children,
  busy = false,
}) {
  return (
    <FlexColumn
      align="stretch"
      fullWidth
      className="ld-surface ld-quiz__card"
      aria-busy={busy || undefined}
      aria-live={busy ? 'polite' : undefined}
    >
      <FlexColumn
        align="start"
        fullWidth
        gap="var(--ds-space-4)"
        className="ld-quiz__card-body"
      >
        <Typography
          component="p"
          variant="bodyExtraSmall"
          fontWeight="semibold"
          className="ld-guidance-step__label"
        >
          {questionLabel}
        </Typography>
        {children}
      </FlexColumn>

      <FlexRow
        align="center"
        justify="between"
        fullWidth
        wrap
        gap="var(--ds-space-4)"
        className="ld-quiz__card-footer"
      >
        {footerStart}
        {footerAction}
      </FlexRow>
    </FlexColumn>
  );
}

QuizCardShell.propTypes = {
  questionLabel: PropTypes.string.isRequired,
  footerStart: PropTypes.node.isRequired,
  footerAction: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  busy: PropTypes.bool,
};
